let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iV5W6")).then(() => parcelRequire('h7zk4'));